import request from '@/utils/request'
export function updateUserStore(id, data) {
  return request({
    url: 'user-stores/' + id,
    method: 'put',
    data: data
  })
}